import { useMountEffect } from '@react-hookz/web';
import * as Sentry from '@sentry/react';
import { getLocation, push } from 'connected-react-router';

import { bffGetOrderIdFromShortCodeUrl } from 'src/app/client/api';
import { bffGetOrderIdFromShortCode } from 'src/app/client/models/order';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { orderTracking } from 'src/app/router/paths';
import { getClient } from 'src/app/state/selectors';
import { useDispatch, useSelector } from 'src/app/state/store';
import { extractErrorCodes } from 'src/app/utils';

export const OrderTrackingRedirect = () => {
  const client = useSelector(getClient);
  const dispatch = useDispatch();

  const dispatchOrderRedirect = async (url: string) => await dispatch(push(url));

  const { pathname } = useSelector(getLocation);
  const shortCode = pathname.replace('/track/', '');
  const dispatchErrorSegmentEvent = useSegmentEvent('error', { shouldTrackOnMount: false });

  useMountEffect(() => {
    const redirect = async () => {
      try {
        const orderIdResult = await bffGetOrderIdFromShortCode(client, shortCode);
        await dispatchOrderRedirect(orderTracking.toPath({ orderId: orderIdResult.data.orderId }));
      } catch (error) {
        Sentry.captureException(error);
        const bffError = error?.error ?? '';
        const api = bffGetOrderIdFromShortCodeUrl(shortCode);
        const trackErrorPayload = {
          errorMessage: 'Order Tracking From Short Code Failed',
          errorSummary: `Title: ${bffError?.title ?? ''} | Flavor Text: ${bffError?.flavorText ?? ''}`,
          api,
          errorCode: extractErrorCodes(error),
          source: window.location.href,
        };
        dispatchErrorSegmentEvent(trackErrorPayload);
      }
    };

    redirect();
  });

  return null;
};
